import React, { useEffect, useRef, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
// import { instance } from 'store/utils';
import { instance } from '../../store/utils';
import { useDispatch, useSelector } from 'react-redux';
import includes from 'lodash/includes';
import { isKtP } from 'utils';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

const Reports = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const user = useSelector(state => state.user);
  const groups = useSelector(state => state.user?.groups);
  const userType = 'provider'; //groups && isKtP(groups) ? "ktp" : "provider";
  const [url, setUrl] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState("");
  const commonList = ["Overview", "Applications"];
  const [usersList, setUsersList] = useState([]);

  const getPowerBiLink = async () => {
    // console.log("ENTERED");
    return await instance
      .get(`/app/rest/reports/${userType}`)
      .then(response => {
        console.log('ENTERED', response);
        return response;
      });
  };

  useEffect(() => {
    getPowerBiLink().then(data => {
      setToken(data.data.embedToken.token);
      setUrl(data.data.embedReports.embedUrl);
    });
  }, []);

  const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,//models.TokenType.Aad, //models.TokenType.Embed, //switched tokens for azure Auth - DR-155
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      background: models.BackgroundType.Transparent,
      //defaultPage: 'ReportSectiona890ba561612d9e4a9a4', //DR-155
    },
  });

  const navigateToPage = async (pageName) => {
    setActivePage(pageName); 
    const report = reportRef.current?._embed;
    if (report) {
      const pages = await report.getPages();
      const page = pages.find(p => p.displayName === pageName);
      if (page) {
        await page.setActive();
      }
    }
  };

  useEffect(() => {
    if(groups){
      getPowerBiLink().then((data) => {
        const embedUrlWithLocale = `${data.data.embedReports.embedUrl}&language=en&formatLocale=en-US`;
        setToken(data.data.embedToken.token);
        setUrl(embedUrlWithLocale);
      });
    }
  }, [groups]);

  useEffect(() => {
      setUsersList(commonList);
  }, [user]);

  useEffect(() => {
    if (token !== '' && url !== '') {
      setReportConfig({
        ...reportConfig,
        embedUrl: url,
        accessToken: token,
        id: url
          .toString()
          .substring(
            url.toString().indexOf('=') + 1,
            url.toString().indexOf('&')
          ),
        filters: [],
        // filters: userType === "provider" ? [
        //   {
        //     $schema: "http://powerbi.com/product/schema#basic", //"http://powerbi.com/product/schema#advanced"
        //     target: {
        //         table: "provider_offer", //table name
        //         column: "provider", //table column name for filter
        //     },
        //     operator: "In", //eq, in etc
        //     values: [user?.info?.provider], //array of values eg. [123,49],
        // }
        // ] : []
      });
      setLoading(false);
    }
  }, [token, url]);

  const applyConditionalFilters = (report) => {
    report.getActivePage().then((page) => {
      //UNCOMMENT THIS AND CUSTOMISE IT AS NEEDED FOR FILTERS
      
      // if (page.displayName !== "Search Vouchers") {
      //   if (userType === "provider") {
      //     const filters = [
      //       {
      //         $schema: "http://powerbi.com/product/schema#basic",
      //         target: {
      //           table: "provider_offer",
      //           column: "provider",
      //         },
      //         operator: "In",
      //         values: [user?.info?.provider],
      //       },
      //     ];
      //     report.setFilters(filters);
      //   } else {
      //     report.setFilters([]);
      //   }
      // } else {
        report.setFilters([]);
      // }
    });
  };

  useEffect(() => {
    const report = reportRef.current?._embed;

    if (report && reportConfig.embedUrl && reportConfig.accessToken && usersList.length > 0) {
      report.on('loaded', async () => {
        await navigateToPage(usersList[0]);
        applyConditionalFilters(report);
      });
      report.on("pageChanged", () => {
        applyConditionalFilters(report);
      });
    }
  }, [reportConfig, user]);

  return (
    // loading ?
    // <></>
    // :
    loading ?
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Spin size="large" />
      </div>
    :
      <div>
        <div className="custom-nav">
          {usersList.map((item) => (
            <button
              className={usersList.length > 1 && activePage === item ? "active" : ""}
              onClick={() => navigateToPage(item)}
              key={item}
            >
              {item==="Vouchers προς Εκκαθάριση" ? "Vouchers Προς Εκκαθάριση" : item}
            </button>
          ))}
        </div>
        <div id="powerbi-container" className="powerbi-report-style-class">
          <PowerBIEmbed
            id="powerbi-report"
            ref={reportRef}
            cssClassName={'report-style-class'}
            embedConfig={reportConfig}
          />
        </div>
      </div>
  );
};

export default Reports;
